export const LOADING_METERS_DIMENSIONS = {
  width: 245,
  height: 275,
} as const;
